import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';

import {ClauseModel} from '../clause/clause.model';
import {ClauseService} from '../core/ecv-http-services/services/clause.service';
import {DictService} from '../core/ecv-http-services/services/dict.service';
import {EndStatisticsService} from '../core/ecv-http-services/services/end-statistics.service';
import {DictModel} from '../dictionary/dict.model';
import {StepComponentAbstract} from '../flow/step.component';
import {ValidatorService} from '../core/validator/validator.service';
import {FinishEcvModel} from './finish-ecv.model';
import {Observable} from 'rxjs/Observable';
import {CandidateClauseType} from '../enums/candidate-clause.enum';
import {WebsiteClausesService} from '@core/ecv-http-services/services/website-clauses.service';
import {WebsiteClauseModel} from './website-clause.model';


@Component({
  selector: 'app-finish-ecv',
  templateUrl: './finish-ecv.component.html'
})
export class FinishEcvComponent extends StepComponentAbstract implements OnInit {
  domainDict: DictModel[] = [];
  finishEcvModel: FinishEcvModel;
  clauses: ClauseModel[] = [];
  userId: number;
  existsPhoneAgreement: boolean;
  candidateClauses: CandidateClauseType[] = [];
  websiteClause: WebsiteClauseModel;

  constructor(private dictService: DictService,
              private clauseService: ClauseService,
              private endStatisticsService: EndStatisticsService,
              private websiteClausesService: WebsiteClausesService,
              private validatorService: ValidatorService) {
    super();
    this.finishEcvModel = new FinishEcvModel();
    this.websiteClause = new WebsiteClauseModel();
  }

  ngOnInit() {
    this.createForm();
    this.loadDictionaries();
  }

  loadData(userId): void {
    this.userId = userId;
    this.clauseService.getAllClauses(userId).subscribe(
      response => {
        this.clauses = response;
      }
    );
    this.endStatisticsService.getEndStatistics(userId).subscribe(
      response => {
        this.finishEcvModel = response;
        this.existsPhoneAgreement = response.existsPhoneAgreement;
        this.candidateClauses = response.candidateClauses;
      }
    );
    this.websiteClausesService.getAllWebsiteClauses(userId).subscribe(
      response => {
        this.websiteClause = response;
      }
    );
  }

  onSave(): Observable<any> {
    if (this.isSaveInProgress) {
      return undefined;
    }
    this.validatorService.validate(this.stepForm);
    if (!this.validatorService.isValid(this.stepForm)) {
      return Observable.of(false);
    }

    let changes: Observable<any>[] = this.updateChanges();
    if (changes.length === 0) {
      return Observable.of(true);
    } else {
      this.isSaveInProgress = true;
      return Observable.forkJoin(changes)
        .map(() => {
          this.isSaveInProgress = false;
        }, () => {
          this.isSaveInProgress = false;
        });
    }
  }

  updateChanges(): Observable<any>[] {
    return [
      this.endStatisticsService.finishProcessingEcv(this.finishEcvModel),
      ...this.saveClauses()
    ];
  }

  removeClause(index: number) {
    this.clauses[index].deleted = true;
  }

  addClause() {
    const newItem: ClauseModel = new ClauseModel();
    newItem.userId = this.userId;
    this.clauses.push(newItem);
  }

  private saveClauses(): Observable<any>[] {
    let changes: Observable<any>[] = [];
    for (const clause of this.clauses) {
      if (clause.id && clause.deleted) {
        changes.push(this.clauseService.deleteClause(clause));
      } else if (clause.deleted) {
        continue;
      } else if (clause.id) {
        changes.push(this.clauseService.updateClause(clause));
      } else {
        changes.push(this.clauseService.createClause(clause));
      }
    }
    return changes;
  }

  private createForm(): void {
    this.stepForm = new FormGroup({
      'domainDictId': new FormControl('', Validators.required),
      'currentClause': new FormControl('')
    });
  }

  private loadDictionaries(): void {
    this.domainDict = this.dictService.getDomains();
    if (this.domainDict.length === 0) {
      this.dictService.domainDictEmitter.subscribe(response => {
        this.domainDict = response;
      });
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/finish-ecv/finish-ecv.component.ts